import axios from 'axios';
import api from './apiConfig';
import { UserData } from '../types/auth';
import { Pup } from '../types/breed';

export const getUserProfile = async (username: string): Promise<UserData> => {
  try {
    const response = await api.get<UserData>(`/api/users/${username}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.error || 'Failed to fetch user profile');
    }
    throw new Error('Network error when trying to fetch user profile');
  }
};

export const getUserPups = async (username: string): Promise<Pup[]> => {
  try {
    const response = await api.get<{ pups: Pup[] }>(`/api/users/${username}/pups`);
    return response.data.pups;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.error || 'Failed to fetch user pups');
    }
    throw new Error('Network error when trying to fetch user pups');
  }
};

export const checkAwards = async (): Promise<{ new_awards: string[]; total_awards: number }> => {
  try {
    const response = await api.get<{ new_awards: string[]; total_awards: number }>('/api/awards/check');
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.error || 'Failed to check awards');
    }
    throw new Error('Network error when trying to check awards');
  }
};